import React from "react";
import { Tooltip } from "antd";
import { BulbFilled } from "@ant-design/icons";
import chatImg from "../../../assets/img/add-chat.png";

export const individualizedFeedbackCount = (row, hasGroupFeedback = false) =>
  (hasGroupFeedback ? 1 : 0) + (row?.positive_feedback?.length ? 1 : 0);

const IndividualizedFeedbackIcon = ({ count = 0, onClick, flash = false }) => (
  <Tooltip title="Feedback">
    <div
      className="flex justify-around text-[12px] h-full items-center text-[#2E4D6B] cursor-pointer"
      onClick={onClick}
    >
      <div className="w-[32px] mr-[5px] relative">
        {flash && (
          <span className="feedback-lightbulb-flash" aria-hidden="true">
            <BulbFilled />
          </span>
        )}
        <img src={chatImg} className="w-full" alt="" />
        <div className="bg-[black] top-0 right-0 absolute flex items-center justify-center text-white w-[16px] h-[16px] rounded-full">
          +
        </div>
      </div>
      <span>{count}</span>
    </div>
  </Tooltip>
);

export default IndividualizedFeedbackIcon;
